import { render, staticRenderFns } from "./PrepTermView.vue?vue&type=template&id=2e679307"
import script from "./PrepTermView.vue?vue&type=script&lang=js"
export * from "./PrepTermView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports